<template>
  <CPagination
    v-if="paginator"
    :active-page.sync="lPage"
    :pages="Math.ceil(paginator.total / paginator.size)"
    align="end"
  />
</template>
<script>
export default {
  props: ["paginator"],
  data() {
    return {
      lPage: 1,
    };
  },
  created() {
    if (this.paginator && this.paginator.page) {
      this.lPage = this.paginator.page;
    }
  },
  watch: {
    lPage(p) {
      if (!p) {
        p = 1;
      }
      this.$emit("change", p);
    },
  },
};
</script>